<template>
    <div class="row">
        <div class="col-12 mx-auto">
            <div class="bg-card rounded border-0">
                <div class="card-header">
                    <div class="input-group">
                        <select class="form-select" v-model="location">
                            <option value="" disabled selected>{{ $trans.get('__JSON__.Select a Location') }}</option>
                            <optgroup :label="group" v-for="(items, group) in locations">
                                <option :value="location.id" v-for="location in items">
                                    {{ location.name }}
                                </option>
                            </optgroup>
                        </select>
                        <select class="form-select" v-model="employee" :disabled="! location">
                            <option value="" selected>{{ $trans.get('__JSON__.All Employees') }}</option>
                            <option :value="employee.user_id" v-for="employee in employees">
                                {{ fullName(employee) }}
                            </option>
                        </select>
                    </div>
                </div>
                <div class="card-body p-0">
                    <div class="table-responsive" v-if="Object.keys(enrollments).length > 0">
                        <table class="table table-hover table-nowrap">
                            <thead class="thead-light">
                            <tr>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Employee') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Starts At') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Ends At') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Job') }}
                                </th>
                                <th scope="col">
                                    {{ $trans.get('__JSON__.Hours') }}
                                </th>
                                <th></th>
                            </tr>
                            </thead>
                            <tbody v-for="(items, user) in enrollments">
                                <tr v-for="enrollment in items">
                                    <th>{{ findEmployee(user) }}</th>
                                    <td v-html="enrollment.shift.start_human"></td>
                                    <td v-html="enrollment.shift.end_human"></td>
                                    <td>
                                        <span class="text-heading font-semibold">
                                            {{ enrollment.shift.job }}
                                        </span>
                                    </td>
                                    <td>
                                        {{ enrollment.shift.duration }}
                                    </td>
                                    <td class="text-end">
                                        <div class="btn-group">
                                            <button type="button" class="btn btn-sm btn-neutral" @click="disenroll(enrollment)">
                                                {{ $trans.get('__JSON__.Disenroll') }}
                                            </button>
                                        </div>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </div>
                    <div class="text-center pb-5" v-else-if="loading">
                        <div class="spinner-border text-primary" role="status">
                            <span class="visually-hidden">{{ $trans.get('__JSON__.Loading...') }}</span>
                        </div>
                    </div>
                    <div class="text-center pb-5" v-else>
                        <em>{{ $trans.get('__JSON__.No records found to show') }}</em>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'PlannedShifts',
    props: {
        view: {
            type: String,
            required: true,
        },
    },
    data() {
        return {
            loading: true,
            location: '',
            employee: '',

            enrollments: [],
            locations: [],
            employees: [],
        }
    },
    watch: {
        location() {
            this.fetchShifts()
            this.fetchEmployees()
        },
        employee() {
            this.fetchShifts()
        },
    },
    methods: {
        disenroll(enrollment) {
            if (! confirm(this.$trans.get('__JSON__.Are you sure?'))) return

            this.loading = true
            axios.post('/api/planned-shifts/action', { action: 'disenroll', id: enrollment.id }).then(response => {
                window.toastr.info(response.data.message, '', {
                    positionClass: 'toast-bottom-right',
                })
                this.fetchShifts()
            })
                .catch(error => window.toastr.error(error.response.data.message ?? this.$trans.get('__JSON__.Something went wrong'), '', {
                    positionClass: 'toast-bottom-right',
                }))
                .finally(() => this.loading = false)
        },
        fullName(employee) {
            return `${employee?.first_name} ${employee?.last_name}`
        },
        findEmployee(id) {
            return this.fullName(this.employees.find(current => current.user_id === id))
        },
        fetchShifts() {
            this.fetch({ type: 'enrollments', location: this.location, view: this.view, employee: this.employee }, response => this.enrollments = response.data.enrollments)
        },
        fetchEmployees() {
            this.fetch({ type: 'employees', location: this.location, view: this.view }, response => this.employees = response.data.employees)
        },
        fetch(data, closure) {
            this.loading = true
            axios.post('/api/planned-shifts', data).then(response => closure(response))
                .catch(error => window.toastr.error(error.response.data.message ?? this.$trans.get('__JSON__.Something went wrong'), '', {
                    positionClass: 'toast-bottom-right',
                }))
                .finally(() => this.loading = false)
        },
    },
    mounted() {
        axios.get('/api/planned-shifts').then(response => {
            const data = response.data
            this.locations = data.locations
        }).finally(this.loading = false)
    }
}
</script>
